const getBrowserLanguage = (): string => {
    return navigator.language || navigator.languages[0] || "en-EN";
};

const getAppLanguage = (): string => {
    if (window.Weglot) return window.Weglot.getCurrentLang();
    return "en-EN";
};

const setAppLanguage = (language: string): void => {
    if (window.Weglot) localStorage.setItem("wglang", language);
};

export const getPreferredLanguage = (): string => {
    // 1. Use App Language (WeGlot)
    const appLanguage = getAppLanguage();
    if (appLanguage) return appLanguage;

    // 2. Fallback to Browser Language
    const browserLanguage = getBrowserLanguage();
    return browserLanguage;
};

// Start using it on app initialization later
export const setPreferredLanguage = (): void => {
    if (localStorage.getItem("wglang")) return;

    const browserLanguage = getBrowserLanguage();
    // Check if browserLanguage is supported by WeGlot or fall back to en-EN
    setAppLanguage(browserLanguage);
};

export const hideLanguageSwitcher = (): void => {
    const weglotSwitcher = document.querySelector(
        ".weglot_switcher"
    ) as HTMLElement;
    if (weglotSwitcher) {
        weglotSwitcher.style.display = "none";
    }
};

export const showLanguageSwitcher = (): void => {
    const weglotSwitcher = document.querySelector(
        ".weglot_switcher"
    ) as HTMLElement;
    if (weglotSwitcher) {
        weglotSwitcher.style.display = "";
    }
};
